import { render, staticRenderFns } from "./the-header-account-mobile.vue?vue&type=template&id=41198b72&"
var script = {}
import style0 from "./the-header-account-mobile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports